// services/getAgentProperties.js
// Fetches paginated listings for a specific agent.
// Wraps getFilteredProperties2 with the agent's remaxId baked in.

import { getFilteredProperties2 } from '@services/getFilteredProperties2'

/**
 * @param {string}  agentId   — agent.remaxId (the ID used to filter properties)
 * @param {number}  page      — 1-based page number
 * @param {string}  lang      — current language
 * @param {string}  [saleType] — optional saleType filter ('sale' | 'rent' | '')
 * @param {string}  [userEmail]
 * @returns {{ properties, pages, count, coordinates }}
 */
export async function getAgentProperties(agentId, page = 1, lang = 'en', saleType = '', userEmail = null) {

  // console.log(agentId)

  const result = await getFilteredProperties2({
    agent:       agentId,
    saleType:    saleType || '',
    bts:         '',
    name:        '',
    district:    '',
    districts:   '',
    area:        '',
    location:    '',
    project:     '',
    category:    '',
    categories:  '',
    minBedrooms: '',
    maxBedrooms: '',
    room:        '',
    currency:    'thb',
    minprice:    '',
    maxprice:    '',
    petfriendly: '',
    seaview:     '',
    beachfront:  '',
    map:         false,
    sort:        'datedesc',
    page,
  }, userEmail, lang)

  return {
    properties:  result?.properties  ?? [],
    pages:       result?.pages       ?? 1,
    count:       result?.count       ?? 0,
    coordinates: result?.coordinates ?? [],
  }
}